export default "__VITE_ASSET__DD$$IqcQ__"